import React from "react";
import "../Styles/phone-menu.css";
import { AnimatePresence, motion } from "framer-motion/dist/framer-motion";
import PhoneNav from "./PhoneNav";
import PhoneAssetStats from "./PhoneAssetStats";
import Stats from "./Stats";

function PhoneMenu({ phoneMenu }) {
  return (
    <AnimatePresence exitBeforeEnter={true}>
      {phoneMenu && (
        <motion.div
          className="phone-menu-container"
          initial={{ left: "-100vw" }}
          animate={{ left: "0px" }}
          exit={{ left: "-110vw" }}
        >
          <PhoneNav />
          <PhoneAssetStats />
          <Stats />
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default PhoneMenu;
